'use strict';

import 'slick-carousel';
/* eslint-disable no-invalid-this */
/* eslint-disable sort-keys */
/* eslint-disable no-lonely-if */
// eslint-disable-next-line
export default function(carousel, options = {
	arrows: false,
	draggable: true,
	fade: true,
	slidesToScroll: 1,
	slidesToShow: 1
}) {

	const carouselContainer = $(carousel);

	if ('appendArrows' in options) {
		const containerId = carouselContainer.attr('id');
		if (containerId) {
			const uniqueContainer = '#' + containerId;
			options.appendArrows = uniqueContainer;
		}
	}

	carouselContainer.slick(options);
}
